import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/Region`;
const ApiRegion = {
  getAll: (params) => {
    const url = `${baseServiceUrl}/getAllRegion`;
    return ServiceApi.get(url, { params });
  },
  getAllRegionsByType: (params) => {
    const url = `${baseServiceUrl}/getAllRegionsByType`;
    return ServiceApi.get(url, { params });
  },
  get: (params) => {
    const url = `${baseServiceUrl}/getRegionById?id=` + params;
    return ServiceApi.get(url, params);
  },
  // get: (id) => {
  //   const url = `${baseServiceUrl}/${id}`;
  //   return ServiceApi.get(url, { params });
  // },
  create: (input) => {
    const url = `${baseServiceUrl}/createRegion`;
    return ServiceApi.post(url, input);
  },
  update: (data) => {
    const url = `${baseServiceUrl}/updateRegion`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllCity: () => {
    const url = `${baseServiceUrl}/getAllCity`;
    return ServiceApi.get(url);
  },
  getAllRegionsByActiveAmusements: () => {
    const url = `${baseServiceUrl}/getAllRegionsByActiveAmusements`;
    return ServiceApi.get(url);
  },
  changeOrderRegions: (params) => {
    const url = `${baseServiceUrl}/changeOrderRegions`;
    return ServiceApi.post(url, params);
  },
};

export default ApiRegion;


